<template>
  <v-card>
    <v-card-title class="font-weight-bold d-flex align-center justify-space-between">
      <span class="text-truncate">{{ $t("pickLanguage") }}</span>
      <v-btn icon @click="$emit('close-dialog')">
        <v-icon>mdi-close-circle</v-icon>
      </v-btn>
    </v-card-title>
    <v-card-subtitle>{{ $t("whatsTheLanguageOfTheVideo") }}</v-card-subtitle>
    <v-card-text>
      <v-chip-group v-model="shortStore.language" @change="changeLanguage" mandatory column color="primary">
        <v-chip filter outlined value="auto">{{ $t("automatic") }}</v-chip>
        <v-chip filter outlined value="bg">{{ $t("bulgarian") }}</v-chip>
        <v-chip filter outlined value="cs">{{ $t("czech") }}</v-chip>
        <v-chip filter outlined value="da">{{ $t("danish") }}</v-chip>
        <v-chip filter outlined value="nl">{{ $t("dutch") }}</v-chip>
        <v-chip filter outlined value="en">{{ $t("english") }}</v-chip>
        <v-chip filter outlined value="fr">{{ $t("french") }}</v-chip>
        <v-chip filter outlined value="fi">{{ $t("finnish") }}</v-chip>
        <v-chip filter outlined value="de">{{ $t("german") }}</v-chip>
        <v-chip filter outlined value="el">{{ $t("greek") }}</v-chip>
        <v-chip filter outlined value="hu">{{ $t("hungarian") }}</v-chip>
        <v-chip filter outlined value="id">{{ $t("indonesian") }}</v-chip>
        <v-chip filter outlined value="it">{{ $t("italian") }}</v-chip>
        <v-chip filter outlined value="ja">{{ $t("japanese") }}</v-chip>
        <v-chip filter outlined value="ko">{{ $t("korean") }}</v-chip>
        <v-chip filter outlined value="lv">{{ $t("latvian") }}</v-chip>
        <v-chip filter outlined value="lt">{{ $t("lithuanian") }}</v-chip>
        <v-chip filter outlined value="no">{{ $t("norwegian") }}</v-chip>
        <v-chip filter outlined value="pl">{{ $t("polish") }}</v-chip>
        <v-chip filter outlined value="pt">{{ $t("portuguese") }}</v-chip>
        <v-chip filter outlined value="ro">{{ $t("romanian") }}</v-chip>
        <v-chip filter outlined value="ru">{{ $t("russian") }}</v-chip>
        <v-chip filter outlined value="sk">{{ $t("slovak") }}</v-chip>
        <v-chip filter outlined value="es">{{ $t("spanish") }}</v-chip>
        <v-chip filter outlined value="sv">{{ $t("swedish") }}</v-chip>
        <v-chip filter outlined value="tr">{{ $t("turkish") }}</v-chip>
        <v-chip filter outlined value="uk">{{ $t("ukrainian") }}</v-chip>
      </v-chip-group>
      <div v-if="['bg', 'el', 'ja', 'ko', 'ru', 'tr', 'uk'].includes(shortStore.language)" class="caption text--disabled mt-1">
        {{ $t("languageInTesting") }}
      </div>
    </v-card-text>
  </v-card>
</template>

<script>
import { useShortStore } from "@/stores/short";

export default {
  name: "LanguageSelect",
  setup() {
    const shortStore = useShortStore();
    return { shortStore };
  },
  data() {
    return {};
  },
  methods: {
    changeLanguage() {
      localStorage.language = this.shortStore.language;
    },
  },
};
</script>
